/**
 * Create or ensure payroll_clarification data_notifications when a bank transaction
 * is payroll unassigned. Used after classification or rule application.
 */

import { supabase } from '@/integrations/supabase/client';
import type { DataNotificationInsert } from '@/integrations/supabase/payrollNotificationsTypes';

export interface PayrollNotificationSnippet {
  merchant?: string | null;
  amount: number;
  date: string;
  source?: string | null;
}

/**
 * Ensures one open payroll_clarification notification exists for the given
 * bank transaction (payroll unassigned). Idempotent: does not duplicate.
 */
export async function ensurePayrollClarificationNotification(
  companyId: string,
  transactionId: string,
  dataSnippet: PayrollNotificationSnippet
): Promise<void> {
  const row: DataNotificationInsert = {
    company_id: companyId,
    type: 'payroll_clarification',
    severity: 'this_week',
    source: 'bank',
    related_entity_type: 'bank_transaction',
    related_entity_id: transactionId,
    title: 'Classify payroll payment',
    description: 'This updates Labor % and weekly cash planning.',
    data_snippet: dataSnippet as Record<string, unknown>,
    status: 'open',
  };

  const { error } = await (supabase as any).from('data_notifications').insert(row);
  if (error && error.code !== '23505') {
    throw error;
  }
}
